/* eslint-disable no-param-reassign */

const initialState = () => ({
  hideScrollToTop: false,
});

export { initialState as state };

export const mutations = {
  updateHideScrollToTop(state, data) {
    state.hideScrollToTop = data;
  },
};

export const actions = {
  updateVisibility({ commit }, { hideScrollToTop }) {
    commit('updateHideScrollToTop', hideScrollToTop);
  },
};
